"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23,1v22H1V1H23 M24,0H0v24h24V0L24,0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2,8.1h2.6c0.7,0,1.2,0.1,1.5,0.2C6.3,8.4,6.5,8.7,6.7,9C6.9,9.3,7,9.7,7,10.1c0,0.4-0.1,0.7-0.2,1 c-0.2,0.3-0.4,0.5-0.6,0.7c0.4,0.1,0.7,0.4,0.9,0.7c0.2,0.3,0.3,0.7,0.3,1.2c0,0.6-0.1,1-0.4,1.4c-0.3,0.4-0.6,0.6-1,0.7 c-0.3,0.1-0.9,0.1-1.8,0.1H2V8.1z M3.3,9.4v1.8h0.8c0.5,0,0.8,0,0.9,0c0.2,0,0.4-0.1,0.5-0.3c0.1-0.2,0.2-0.4,0.2-0.6 c0-0.2-0.1-0.4-0.2-0.6C5.5,9.6,5.4,9.5,5.3,9.5C5.1,9.4,4.7,9.4,4,9.4H3.3z M3.3,12.5v2.1h1.2c0.5,0,0.9,0,1-0.1 c0.1-0.1,0.3-0.2,0.4-0.3C6,14,6,13.8,6,13.6c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.4-0.3c-0.2-0.1-0.5-0.1-1.1-0.1H3.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.4,15.9V8.1h2.1c0.8,0,1.3,0,1.5,0.1c0.4,0.1,0.7,0.4,0.9,0.8c0.2,0.4,0.4,0.9,0.4,1.5c0,0.6-0.1,1-0.3,1.4 c-0.2,0.4-0.5,0.6-0.8,0.8c-0.3,0.2-0.9,0.2-1.6,0.2H9.7v2.9H8.4z M9.7,9.4v2.2h0.7c0.5,0,0.8,0,1-0.1c0.2-0.1,0.3-0.2,0.4-0.4 c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.5-0.2-0.7c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-1.1-0.1H9.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.2,15.9l-1.5-7.8H15l1,5.3l1.2-5.3h1.5l1.1,5.4l1-5.4H22l-1.5,7.8h-1.4l-1.3-5.8l-1.3,5.8H15.2z"
  }));
};

exports["default"] = _default;